import {reactive} from 'vue'
import Keycloak, {KeycloakConfig} from "keycloak-js";

let initOptions: KeycloakConfig = {
    url: import.meta.env.VITE_KEYCLOAK_HOST,
    realm: 'Histeria',
    clientId: 'public'
}

let initPromise: Promise<boolean> | null = null;

function buildRedirectUri(path: string): string {
    return window.location.origin + path;
}

export const keycloakStore = reactive({
    keycloak: new Keycloak(initOptions),
    isKeycloakInit: false,

    init() {
        if (!initPromise) {
            initPromise = this.keycloak.init({
                onLoad: 'check-sso',
                // Use a hidden iframe to check the SSO session instead of a full-page
                // redirect. Without this, navigating to an auth-guarded page (e.g. /admin)
                // triggered a top-level redirect to Keycloak that bounced the user around.
                silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
                pkceMethod: 'S256',
                checkLoginIframe: false,
            }).then((auth) => {
                this.isKeycloakInit = true;
                return auth;
            }).catch((error) => {
                initPromise = null;
                console.error('Keycloak init failed', error);
                throw error;
            });
        }
        return initPromise;
    },

    async requireAuth(path: string): Promise<boolean> {
        await this.init();
        if (this.keycloak.authenticated) {
            return true;
        }
        this.keycloak.login({redirectUri: buildRedirectUri(path)});
        return false;
    },

    async loginUser(redirectionUrl: string) {
        // createLoginUrl() is async since keycloak-js 25.
        const url = await keycloakStore.keycloak.createLoginUrl({redirectUri: redirectionUrl});
        window.open(url, '_self')
    }
})
